import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Pagination from "components/ui/pagination/Pagination";

export default function PendeingDataTable({data}) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const navigatefunction = (id, Status) => {
      navigate(`${id}/${Status}`);
    };
    /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const pendingData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
            <Tr>
              <Th> # </Th>
              <Th>{t("pages.purchase_orders.refrences")}</Th>
              <Th>{t("pages.purchase_orders.suplliers")}</Th>
              <Th>{t("pages.purchase_orders.destination")}</Th>
              <Th>{t("pages.purchase_orders.status")}</Th>
              <Th>{t("pages.purchase_orders.business_date")}</Th>
              <Th>{t("pages.purchase_orders.created")}</Th>
            </Tr>
        </Thead>
        <Tbody>
            {
            pendingData?.map((item, index) => (
              <Tr
                  key={item.PurchaseOrdersId}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigatefunction(item.PurchaseOrdersId, item.Status)
                  }
                >
                  <Td> {index + 1} </Td>
                  <Td> {item.PurchaseOrdersRef} </Td>
                  <Td> {item.SuppliersName} </Td>
                  <Td> {item.Destination} </Td>
                  <Td> {item.Status} </Td>
                  <Td> {item.BusinessDate} </Td>
                  <Td> {item.CreatedDate} </Td>
              </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
           currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
